<template>
  <div class="college-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "College"
};
</script>

<style lang="scss" scoped>
.college-container {
  width: 100%;
  height: 100%;
}
</style>
